var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServicesImgSec(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M699.46,265.47s10-178-141-227-227-13-275,33-64,76-119,82-106,16-132,83,7,120,57,153,108-2,154,19,75,56,169,60,97-23,145-65S690.46,405.47,699.46,265.47Z",
    style: {
      fill: "#7474E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.46,265.47s10-178-141-227-227-13-275,33-64,76-119,82-106,16-132,83,7,120,57,153,108-2,154,19,75,56,169,60,97-23,145-65S690.46,405.47,699.46,265.47Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M591,228.1c4.07,1.78,14,1.56,14,1.56s-2.14-6.52-2.33-6.92c-2.18-4.57-9.1-12.12-14.72-11.36a6.72,6.72,0,0,0-5.39,8.42C583.52,223.69,587.52,226.59,591,228.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.43,257c4.22.61,13.11-2,13.82-2.17a119.48,119.48,0,0,0,5.39,14.92c1.22,2.83,2.54,5.64,3.9,8.44-.81-1.18-1.54-2.24-1.66-2.38-3.32-3.83-12-9.28-17.2-7.07a6.71,6.71,0,0,0-3,9.54c1.93,3.52,6.55,5.25,10.3,5.8s11.42-1.49,13.43-2.06c.53,1.07,1.05,2.14,1.59,3.21,2.58,5.13,5.17,10.23,7.55,15.31.85,1.8,1.61,3.59,2.38,5.38-.72-1.05-1.34-1.93-1.44-2.06-3.32-3.83-12-9.29-17.2-7.07a6.71,6.71,0,0,0-3,9.54c1.93,3.51,6.55,5.25,10.3,5.8s10.68-1.3,13.07-2c.73,1.86,1.47,3.72,2.1,5.55.4,1.27.87,2.46,1.2,3.75s.71,2.53,1,3.77c.59,2.43,1.2,4.93,1.71,7.3.37,1.66.68,3.24,1,4.83-.82-1.79-2.49-5.27-2.67-5.54-2.69-4.29-10.43-11-15.93-9.6a6.71,6.71,0,0,0-4.38,9c1.37,3.77,5.68,6.18,9.3,7.29,4,1.22,12.8.1,13.91,0,.52,2.63,1,5.2,1.44,7.64.94,5.36,1.66,10.17,2.2,14.24h3.72c-.65-4.21-1.5-9.23-2.62-14.86-.52-2.68-1.14-5.53-1.8-8.46a70.94,70.94,0,0,0,7.76-3.65c2.91,3.15,10.35,6.83,11.31,7.3-1,2.49-2,4.9-3,7.16-2.06,4.74-4,8.94-5.74,12.51h4c1.49-3.29,3.12-7,4.82-11.2,1-2.52,2.1-5.24,3.16-8,1.07.22,9.8,2,13.87,1.07,3.69-.83,8.17-2.92,9.82-6.57a6.71,6.71,0,0,0-3.71-9.28c-5.38-1.81-13.59,4.3-16.6,8.38-.17.24-1.81,3.07-2.81,4.87.43-1.15.86-2.26,1.28-3.45.86-2.34,1.65-4.7,2.5-7.23.38-1.24.75-2.5,1.13-3.76s.67-2.61,1-3.93c.73-3.07,1.32-6.22,1.85-9.41,2,.75,9.37,3.3,13.16,3s8.52-1.65,10.7-5a6.72,6.72,0,0,0-2.25-9.74c-5.05-2.6-14.09,2.2-17.68,5.77-.23.23-2.51,3.08-3.74,4.67.3-1.91.61-3.83.85-5.78.7-5.62,1.23-11.34,1.79-17,.17-1.75.36-3.49.54-5.23.73.28,9.36,3.49,13.61,3.19,3.78-.26,8.51-1.65,10.7-5a6.71,6.71,0,0,0-2.26-9.73c-5-2.6-14.08,2.19-17.67,5.77-.27.27-3.56,4.38-4.35,5.47.41-3.84.85-7.65,1.43-11.4a119.84,119.84,0,0,1,3.27-15c.34.13,9.34,3.53,13.69,3.22,3.78-.26,8.51-1.65,10.7-5a6.71,6.71,0,0,0-2.26-9.73c-5-2.6-14.08,2.19-17.67,5.77-.29.28-3.82,4.7-4.4,5.55.08-.28.13-.59.22-.87a86.56,86.56,0,0,1,5.94-14.18c1.29-2.53,2.67-4.87,4.05-7.12,1.62.81,9,4.4,13,4.56,3.78.15,8.64-.71,11.18-3.8a6.72,6.72,0,0,0-1.17-9.93c-4.73-3.14-14.25.63-18.21,3.79-.21.17-2.21,2.16-3.65,3.63.65-1,1.29-2,1.93-3,2.37-3.58,4.76-6.71,6.91-9.46,1.23-1.55,2.37-2.94,3.46-4.22,2,0,10-.28,13.53-1.93s7.34-4.61,8.17-8.52a6.71,6.71,0,0,0-5.61-8.27c-5.65-.61-12.35,7.12-14.41,11.75-.18.4-2.25,7-2.14,7h.12c-1.07,1.21-2.2,2.52-3.41,4-2.21,2.71-4.68,5.8-7.14,9.33A120.11,120.11,0,0,0,687.1,238a88,88,0,0,0-6.32,14.23c0,.06,0,.12,0,.18,0-1.66,0-6.31-.09-6.67-.65-5-4.86-14.35-10.44-15.38a6.71,6.71,0,0,0-7.75,6.31c-.33,4,2.57,8,5.39,10.51,3.18,2.85,12,5.6,12.73,5.82a117.67,117.67,0,0,0-3.74,15.42c-.54,3-1,6.11-1.4,9.2,0-1.44,0-2.73-.08-2.91-.65-5-4.86-14.35-10.44-15.38a6.71,6.71,0,0,0-7.75,6.31c-.33,4,2.57,8,5.39,10.51s10.35,5.06,12.34,5.7c-.14,1.18-.3,2.37-.44,3.55-.68,5.7-1.34,11.39-2.15,16.94-.29,2-.64,3.88-1,5.8,0-1.28,0-2.35-.07-2.51-.65-5-4.86-14.36-10.44-15.39a6.72,6.72,0,0,0-7.75,6.32c-.32,4,2.57,8,5.4,10.51s9.62,4.81,12,5.57c-.41,2-.83,3.92-1.32,5.8-.36,1.27-.62,2.52-1.06,3.78s-.8,2.5-1.2,3.73c-.85,2.35-1.72,4.77-2.61,7-.6,1.58-1.21,3.07-1.82,4.58.31-2,.83-5.77.84-6.1a26,26,0,0,0-3.5-12.68,7.41,7.41,0,0,0-.09-1.49,6.72,6.72,0,0,0-8.21-5.7c-5.49,1.46-9,11.09-9.22,16.15,0,.3.17,3.56.33,5.61-.27-1.19-.53-2.35-.83-3.58-.57-2.42-1.22-4.83-1.9-7.42q-.57-1.84-1.14-3.75c-.35-1.26-.88-2.55-1.32-3.83-1.09-3-2.33-5.92-3.65-8.87,2.12-.51,9.63-2.42,12.65-4.74s6.19-6.07,6.16-10.08a6.71,6.71,0,0,0-7.25-6.87c-5.64.61-10.54,9.6-11.57,14.56-.06.31-.39,3.95-.54,6-.8-1.77-1.6-3.53-2.48-5.29-2.52-5.08-5.23-10.14-7.91-15.2-.82-1.55-1.62-3.11-2.43-4.66.76-.17,9.74-2.26,13.12-4.85,3-2.3,6.18-6.07,6.16-10.08a6.71,6.71,0,0,0-7.26-6.87c-5.64.61-10.54,9.6-11.56,14.56-.08.37-.55,5.62-.61,7-1.77-3.42-3.51-6.85-5.09-10.3a118.9,118.9,0,0,1-5.54-14.3c.35-.08,9.73-2.21,13.19-4.87,3-2.3,6.19-6.07,6.16-10.08a6.7,6.7,0,0,0-7.25-6.87c-5.64.61-10.54,9.6-11.56,14.56-.08.39-.59,6-.61,7.06-.08-.28-.21-.57-.29-.85a86.2,86.2,0,0,1-2.87-15.11c-.32-2.81-.46-5.53-.54-8.17,1.78-.21,9.94-1.3,13.32-3.35s6.82-5.35,7.23-9.34a6.72,6.72,0,0,0-6.45-7.63c-5.68,0-11.53,8.39-13.1,13.21-.08.26-.65,3-1,5,0-1.2-.06-2.43,0-3.57,0-4.29.28-8.22.55-11.7.16-2,.36-3.76.55-5.43,1.65-1.13,8.21-5.76,10.23-9.07s3.58-7.9,2.11-11.62a6.72,6.72,0,0,0-9.25-3.8c-5,2.6-6.36,12.75-5.53,17.75.07.43,2,7.06,2.06,7l.1-.07c-.22,1.6-.44,3.32-.64,5.2-.35,3.48-.7,7.42-.8,11.73a116.26,116.26,0,0,0,.33,13.91A87.4,87.4,0,0,0,608,254c0,.06,0,.12,0,.18-.89-1.41-3.52-5.24-3.75-5.52-3.32-3.83-12-9.29-17.2-7.07a6.72,6.72,0,0,0-3,9.54C586.06,254.68,590.68,256.41,594.43,257Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.74,230.29c.09.06,1.82-6.62,1.88-7,.69-5-.91-15.13-6-17.6a6.71,6.71,0,0,0-9.13,4.05c-1.37,3.77.36,8.38,2.42,11.56C683.31,225,691.74,230.29,691.74,230.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "678.84 412.16 624.39 412.16 617.59 351.69 685.65 351.69 678.84 412.16",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "618.84 362.76 619.5 368.62 683.74 368.62 684.4 362.76 618.84 362.76",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "682.29 381.51 682.95 375.65 620.29 375.65 620.95 381.51 682.29 381.51",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-37"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.89,105.48V88l-17.45-1.94a41.48,41.48,0,0,0-4.27-10.4l11-13.77L145.83,49.56l-13.71,11a41.85,41.85,0,0,0-10.37-4.35l-1.94-17.52H102.34L100.4,56.1A41.88,41.88,0,0,0,90,60.38l-13.77-11L63.88,61.71l11,13.72a41.23,41.23,0,0,0-4.34,10.36L53,87.74v17.47l17.45,1.94a41.41,41.41,0,0,0,4.27,10.39l-11,13.78L76,143.67l13.71-11A41.83,41.83,0,0,0,100.12,137l1.94,17.52h17.47l1.94-17.44a41.51,41.51,0,0,0,10.4-4.28l13.77,11L158,131.51,147,117.8a41.45,41.45,0,0,0,4.34-10.37Zm-57.95,12a20.85,20.85,0,1,1,20.84-20.85A20.85,20.85,0,0,1,110.94,117.46Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.52,70.42l-1.93-11.56-11.77.65a27.89,27.89,0,0,0-4-6.41l5.77-10.34L216.06,36l-7.86,8.78A27.93,27.93,0,0,0,200.85,43l-3.23-11.39-11.56,1.94.65,11.76a27.89,27.89,0,0,0-6.41,4L170,43.54l-6.81,9.54L171.93,61a27.86,27.86,0,0,0-1.72,7.34l-11.39,3.23,1.94,11.56,11.76-.64a27.83,27.83,0,0,0,4,6.4l-5.76,10.34,9.54,6.81,7.87-8.78a28.27,28.27,0,0,0,7.34,1.73l3.23,11.38,11.56-1.93-.64-11.77a27.83,27.83,0,0,0,6.4-4l10.34,5.77,6.81-9.55L224.41,81a28.37,28.37,0,0,0,1.73-7.34Zm-37,14.35A14,14,0,1,1,212,68.66,14,14,0,0,1,200.48,84.77Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.51,80.75H610.18A10.46,10.46,0,0,1,620.63,91.2V389.44a0,0,0,0,1,0,0H145a0,0,0,0,1,0,0V91.2A10.46,10.46,0,0,1,155.51,80.75Z",
    style: {
      fill: "#7474E5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.51,
    y: 374.58,
    width: 326.85,
    height: 16.1,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.51,
    y: 382.33,
    width: 326.85,
    height: 8.35,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.59,400.23s5.37,6.56,21.47,11.93H639.8s11.93-3,17.3-11.34Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.5,
    y: 388.48,
    width: 552.76,
    height: 12.54,
    rx: 1.89,
    style: {
      fill: "#7474E5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 382.74,
    cy: 90.08,
    r: 4.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.34,
    y: 104.86,
    width: 437,
    height: 246.96,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.34,
    y: 104.86,
    width: 437,
    height: 14.95,
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-37"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 23.22,
    y1: 412.16,
    x2: 719.32,
    y2: 412.16,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Video--inject-37"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 385.86,
    y: 233.24,
    width: 180.49,
    height: 101.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.86,
    y: 322.96,
    width: 180.49,
    height: 12.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 385.86,
    y: 327.45,
    width: 180.49,
    height: 3.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 477.07,
    cy: 278.97,
    r: 19.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "491.73 279.05 467.18 264.88 467.18 293.23 491.73 279.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-37"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 386.16,
    y: 137.74,
    width: 180.03,
    height: 85.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "386.16 222.94 451.14 172.27 486.31 191.94 528.04 154.98 566.19 179.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 410.01,
    cy: 161.54,
    r: 13.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-37"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 200.77,
    y: 237.24,
    width: 13.11,
    height: 95.38,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.85,
    y: 280.17,
    width: 13.11,
    height: 52.46,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.92,
    y: 295.07,
    width: 13.11,
    height: 37.56,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258,
    y: 265.26,
    width: 13.11,
    height: 67.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.07,
    y: 271.82,
    width: 13.11,
    height: 60.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.15,
    y: 319.51,
    width: 13.11,
    height: 13.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.61,
    y1: 244.4,
    x2: 355.17,
    y2: 244.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.61,
    y1: 256.92,
    x2: 355.17,
    y2: 256.92,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.61,
    y1: 269.43,
    x2: 355.17,
    y2: 269.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.61,
    y1: 281.95,
    x2: 355.17,
    y2: 281.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.61,
    y1: 294.47,
    x2: 355.17,
    y2: 294.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.61,
    y1: 306.99,
    x2: 355.17,
    y2: 306.99,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.61,
    y1: 319.51,
    x2: 355.17,
    y2: 319.51,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 317.61,
    y1: 332.03,
    x2: 355.17,
    y2: 332.03,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.51,193.68l-8.18-50.21h5.82l5.4,36.08,6.75-35.89h5l6.82,36.08,5.27-36.27h5.7L232,193.68h-5.08l-7-37.19-7.07,37.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 253.82,
    y1: 146.08,
    x2: 357.82,
    y2: 146.08,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 253.82,
    y1: 157.11,
    x2: 357.82,
    y2: 157.11,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 253.82,
    y1: 168.14,
    x2: 357.82,
    y2: 168.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 253.82,
    y1: 179.17,
    x2: 357.82,
    y2: 179.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 253.82,
    y1: 190.2,
    x2: 357.82,
    y2: 190.2,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--code-3--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M580.32,211H519.88c-3.38,0-6.15,3.4-6.15,7.56V258.9c0,4.15,2.77,7.55,6.15,7.55h14.48l-9.47,20.87,25.25-20.87h30.18c3.38,0,6.14-3.4,6.14-7.55V218.57C586.46,214.41,583.7,211,580.32,211Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.62,251.52l-12.71-9v-4.76l12.71-9.07v4.81l-9.11,6.62,9.11,6.62Z",
    style: {
      fill: "#7474E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.49,253.12l9.69-36h4.13l-9.73,36Z",
    style: {
      fill: "#7474E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.18,251.52v-4.76l9.16-6.66-9.16-6.58v-4.81l12.76,9v4.76Z",
    style: {
      fill: "#7474E5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--code-2--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M576.38,75.85H516c-3.38,0-6.15,3.4-6.15,7.55v40.33c0,4.16,2.77,7.56,6.15,7.56h14.47L521,152.15l25.26-20.86h30.17c3.38,0,6.15-3.4,6.15-7.56V83.4C582.53,79.25,579.76,75.85,576.38,75.85Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.69,116.35l-12.72-9v-4.75l12.72-9.07v4.8L526.58,105l9.11,6.63Z",
    style: {
      fill: "#7474E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.56,118l9.69-36h4.13l-9.73,36Z",
    style: {
      fill: "#7474E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.25,116.35V111.6l9.16-6.67-9.16-6.58v-4.8l12.76,9v4.76Z",
    style: {
      fill: "#7474E5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--code-1--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M338.89,180H278.45c-3.38,0-6.15,3.4-6.15,7.55V227.9c0,4.16,2.77,7.56,6.15,7.56h14.48l-9.47,20.86,25.25-20.86h30.18c3.38,0,6.14-3.4,6.14-7.56V187.57C345,183.42,342.27,180,338.89,180Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.19,220.52l-12.71-9v-4.75l12.71-9.07v4.8l-9.11,6.62,9.11,6.63Z",
    style: {
      fill: "#7474E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.06,222.12l9.69-36h4.14l-9.74,36Z",
    style: {
      fill: "#7474E5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.75,220.52v-4.75l9.16-6.67-9.16-6.58v-4.8l12.76,9v4.76Z",
    style: {
      fill: "#7474E5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mug--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.94,385.08h-.14c-.58-.05-5.7-.61-6.83-4-.87-2.63-.89-10,1.15-12.33,1.87-2.13,4.75-1.1,6-.26a1.5,1.5,0,0,1-1.66,2.5s-1.51-.93-2.09-.27c-1,1.12-1.33,7.1-.56,9.41.37,1.1,2.76,1.82,4.26,2a1.5,1.5,0,0,1-.14,3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.09,
    y: 366.05,
    width: 18,
    height: 22.11,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.54,363a9.38,9.38,0,0,1,1.07-7.05c2.13-3.42,6.4-4.06,6.19-10",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.65,353.81a32.6,32.6,0,0,1-2.78,4.05,8.24,8.24,0,0,0-1.5,5.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.57,350a13.58,13.58,0,0,0,.85-6.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-37"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.72,230.88s-.88-3.83-3.13-3.56-1.53,1-3.67.44-2.57-2.38-3.62-.8.93,2.58-1,2.39-2.65-1.34-3.39-.63a5.52,5.52,0,0,0-1.08,1.37l-.31.87a2,2,0,0,1,3-.78c2,1.21,3.49,1.45,3.78.38s2.78-1,2.85-.35a3.2,3.2,0,0,0,.79,1.36s-5.54.46-7.17.65-2.83-1.11-5.18,0-4.3,2.17-5.17,3.52,1.19,3,.9,4-4.48,2.41-4.3,3.83,2.06,1.62.14,2.89-3.61,2.71-3.06,3.89,2,2.45,1.69,3.73-2.46,3.61-1.29,4.71,1.88.19,1.67,1.87-1.25,5.12,0,5.59,2.83,1.11,2.82,2.77-.27,2.93.88,3.83,3.82.78,4.11,3.23.6,3.24,1.7,3.73,2.81-.75,3.66,1.22,3.34,1.88,4.51,1.32,2.1-1.49,3.19.65,2.36,2.41,3.94,1.81,3.91-.27,4.87.86,3.21.86,4.34-.11,1.93-2.92,2.94-1.39,3.46,2.9,4.33,1.55,1.44-3.48,2.82-2.41a2.9,2.9,0,0,0,4.06-.69,4.28,4.28,0,0,1,3.88-2.13c1.69.22,3.75.17,3.71-1.89s-.21-3.5,1.47-3.29,4.23.74,4.19-1.33-.19-3.29,1-3.44,3.09-1.82,2.74-3-1.28-5.44-.66-5.51,1.43-1.83.57-3.8-1-3.6-.46-3.88,1.13-2.62-.29-4.11-2-2.66-.85-3.63a2.73,2.73,0,0,0-.08-4.13c-1.4-1.28-2.14-2.23-2.26-3.25s-2.87-3.18-3.76-3.69a5.32,5.32,0,0,1-2.15-4.09c-.27-2.25-.7-2.4-4.57-3.59a18.43,18.43,0,0,1-6.39-3.17c-1.58-1.05-5.46-.59-7,.43S148,225.84,145.72,230.88Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.49,335.5c6.61-5.12,20.59-28.33,20.59-28.33s1.68,11.85,3.64,17.51,4.63,9.37,4,15.87c0,0-.06-1-.06-1l35.85,1.05c-1.1-2-1.8-2.34-2-3.21-.59-3.05,2.54-9.82,2.58-12.91s2.38-9,2.38-9,10.34,22.91,12.71,24.84,9,3,8.63-4.18-12.45-34.95-14.57-39.78-4.78-8.18-9.9-7.69-6.31,1.38-9.8,1.57-1.95-16.57-1.95-16.57a12.77,12.77,0,0,1-12.67,1.94s.9,8.8-.59,11.56-2.27,3.63-5.84,2.39-9.16-5.47-12.57-3.84-27.36,41.48-29.23,44.88c-1.24,2.25-4.58,8-3.58,9.55Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.68,340.55c0-.34.06-.66.07-1h-.13S132.68,340.57,132.68,340.55Z",
    style: {
      fill: "#7474E5",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.92,285.75c-3.41,1.63-27.36,41.48-29.23,44.88-1.24,2.25-4.58,8-3.58,9.55l12.38-4.68c6.61-5.12,20.59-28.33,20.59-28.33s1.68,11.85,3.64,17.51c1.86,5.36,4.35,9,4,14.89l35.72,1.05c-1.1-2-1.8-2.34-2-3.21-.59-3.05,2.54-9.82,2.58-12.91s2.38-9,2.38-9,10.34,22.91,12.71,24.84,9,3,8.63-4.18-12.45-34.95-14.57-39.78-4.78-8.18-9.9-7.69a40.47,40.47,0,0,0-5.44.88l-14.84,18.07-10.57-18.06C133.92,288.34,128.33,284.12,124.92,285.75Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.08,337.79s-18.91,16.35-19.34,31.74c-.15,5.34.87,17.27,10,18.53s49.57,0,49.57,0,3.15-.95,5-11.63-11.94-38-11.94-38Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147,344.3s-3.45,4.28-4,4.49-1.15,1.88-2.3,4.38-.83,2.72.53,2.09,2.71-3.44,2.71-3.44l2.61-1.67S149.16,343.57,147,344.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.38,332.83s-3.23,4.37-10.74,7.71-14.8,2.34-18.91,2.53-4.73-.74-6.48,2.55-.19,12.32.66,12.9,1-3.59,1-3.59.75,4,1.95,4.08,1.58-3.41,1.58-3.41,1.06,2.46,2,2.13.77-3,.77-3,1.18,1.55,1.76.7-.81-6-.81-6,5.32.87,7.27.21a6.5,6.5,0,0,0,3-2.2,122.06,122.06,0,0,0,15.57-.92c5.89-1,14.05-7.09,12.16-10.88S185,331,185,331",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.19,354.78s-1.93-5.56-1.17-7.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.39,355.6s-1.31-5.38-1-8.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.86,354.93s-1-5.88-.32-7.19",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.38,332.83a23.75,23.75,0,0,1-5.49,4.82c2,1.51,4.08,4.15,4.78,8.77,5.81-1.3,13.28-7.1,11.46-10.74S185,331,185,331",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.36,320.58a24.91,24.91,0,0,0,4.33-1.5c2.23-1,3.77-3.26,4.45-2.4s.19,2.42-1.1,3.52a37.48,37.48,0,0,1-5.06,3S121.92,322.4,123.36,320.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114,329.38s5.1-13.53,7.42-13.57,13.32,1.91,12.8,3-1.84,1.43-3.16,1.38a54.27,54.27,0,0,1-6.24-1.43l-1.44,1.81s5.08,1.46,5.86,1.83,3.79,3.34,3,4.52-1.08.64-1.08.64a3.09,3.09,0,0,1,0,2.1c-.45.94-.92.72-.92.72h0a1.57,1.57,0,0,1-2.14,1.32c-1.14-.44-1.16-2.61-2.56-2.43-1.59.19-1.85-.09-1.85-.09a49.7,49.7,0,0,1-4.81,4.06,8.71,8.71,0,0,1-4.48,1.33s-9.36,7.89-17.29,8.88c-8.83,1.1-5.83-8.4-1.41-12.83S114,329.38,114,329.38Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.18,327.57s-1.68-2.77-2.78-3.29a27.89,27.89,0,0,0-4.68-1.06",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.23,330.39s-2.59-3.79-3.4-3.84-3.46-.48-3.46-.48",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.25,335.65a13.56,13.56,0,0,1,3.84-7.35c-3,.12-5.81.72-7.4,2.33-4.42,4.43-7.42,13.93,1.41,12.83a21,21,0,0,0,5.29-1.5C100.63,340.51,98.94,338.37,99.25,335.65Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.6,273.38c.69,3,.17,5.67-1.15,6s-3-1.89-3.65-4.89-.17-5.67,1.16-6S165.91,270.38,166.6,273.38Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.24,275.29c0,2.9-1.1,5.24-2.4,5.23s-2.31-2.38-2.28-5.28S135.66,270,137,270,139.27,272.39,139.24,275.29Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.47,248.79s-3,.71-3,3,.31,3.08-1.45,3.79-2.7,1.29-2.43,2.92,1,2.12-1.24,2.5-2.07-1.11-2.54,1.05-.56,2.81-1.38,2.95.19,7.27,2.16,11.52,6.58,10.57,9.35,10.94,6.33-3,8.81-5.87c2.23-2.59,5.53-10.52,5.53-10.52l.71-.75s1.25,0,1.58-1.73c0,0-.24-2.67-1.59-3.27a6.67,6.67,0,0,1-2.85-3.28c-.1-.61.57-1.55-.34-2s-2.44-.85-2.88-2.23,1.07-3.52-.72-4.26-2.74-.16-3-1.58.54-3-.82-3.62S148.47,248.79,148.47,248.79Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.5,267.59c.21,1.26,0,2.36-.56,2.45s-1.12-.87-1.33-2.13,0-2.37.56-2.45S144.28,266.32,144.5,267.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.79,267.72c0,1.28-.45,2.32-1,2.31s-.95-1-.93-2.33.45-2.32,1-2.32S153.81,266.43,153.79,267.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145,277.34s2,2.64,7.64,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.21,264.18s2.83-3,6.2-1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.81,263s3.73-2.57,7.78,1.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.08,271.05a3.8,3.8,0,0,0-.28,1.43,2.32,2.32,0,0,0,2.55,1.81,2.13,2.13,0,0,0,1.73-3.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.15,361.6a9.77,9.77,0,0,0-4.35,1.79c-5.86,4.29-4.35,14-4.55,20.38q-.37,12.11-.78,24.19c-.39,11.86-.57,23.75-1.33,35.59-.58,9.08-3.14,23.22-1.19,32.88s7,7.53,9.73-1.38-1-26.26-1.34-30.18c-.26-3.06,13.77-49.34,17.54-70.3C168.27,366.82,160.24,360.51,153.15,361.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,465.31c-2.58-.59-4.28-3.77-5.34-6.76-.54,6.27-.79,12.71.25,17.88,2,9.65,7,7.53,9.73-1.38,1-3.36,1.13-7.92.85-12.51C150.17,464.39,148.34,465.83,146,465.31Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.43,360.88a9.79,9.79,0,0,1,4.6.95c6.54,3.14,6.85,12.93,8.23,19.2q2.61,11.82,5.23,23.63c2.57,11.58,4.94,23.24,7.88,34.73,2.25,8.81,7.37,22.24,7.23,32.09s-5.51,8.7-9.82.44-3.83-26-4.24-29.91c-.32-3-22.65-45.95-30.22-65.85C115.52,368.8,122.26,361.12,129.43,360.88Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.55,461.5c2.43-1.06,3.51-4.5,4-7.63,1.69,6.06,3.12,12.35,3,17.61-.13,9.85-5.51,8.7-9.82.44-1.62-3.11-2.57-7.57-3.14-12.13C151.32,461.35,153.38,462.44,155.55,461.5Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.18,
    y: 322.68,
    width: 61.56,
    height: 38.24,
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.18,
    y: 360.05,
    width: 61.56,
    height: 2.21,
    style: {
      fill: "#c9c9c9",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesImgSec);
export default __webpack_public_path__ + "static/media/servicesImgSec.aa61177a1988f0677b42124560b3ec29.svg";
export { ForwardRef as ReactComponent };